export default "__VITE_ASSET__BFIk1glN__"